// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rugby/XDL/types";

import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        cssOverrides: {
            currentButton: css`
                color: ${getColor("text.main")};
                background: ${getColor("common.ui3")};
                text-shadow: none;
            `,
            linkList: css`
                ul li button {
                    min-height: 30px;
                    padding: 0 8px;
                    text-shadow: none;
                    color: ${getColor("secondary")};
                }

                ul li button[data-test-selector="paginationButtonNext"],
                ul li button[data-test-selector="paginationButtonLast"],
                ul li button[data-test-selector="paginationButtonPrevious"],
                ul li button[data-test-selector="paginationButtonFirst"] {
                    width: auto;
                    background: transparent;
                    padding: 0 4px;
                    text-shadow: none;
                    color: #869da2;
                }
            `,
        },
    },
} as xBaseTheme["pagination"];
